/**
 * @file
 * Скопированно с небольшими изменениями из header-footer-app
 * @see https://gitlab.mos-team.ru/mos-front/header-footer-app/blob/NAVIGATION/app/helpers/url.js
 */

const developmentCircuits = [
  /beta.alt.mos.ru/,
  /newmos.mos.ru/,
  /\w+-tech.mos.ru/,
  /manage\w*.mos.ru/,
  /dev-\w+.mos.ru/,
  /\w+.local.mos-team.ru/,
  /localhost/,
  /(10|127).(\d|.)*/,
];

const elkDevelopmentCircuits = [
  /my-tech.mos.ru/,
  /dev-my.mos.ru/,
  /ulk-tech.mos.ru/,
];

const getDomain = (): string | null => {
  const scriptElement: Element | null =
    document.querySelector("#mos-layouts-boot");
  return scriptElement ? scriptElement.getAttribute("data-domain") : null;
};

export function getCircuitPath(url = ""): string {
  const isCircuit = developmentCircuits.some((circuit: RegExp): boolean =>
    circuit.test(window.location.host)
  );

  const isElkDevelopmentCircuit = elkDevelopmentCircuits.some(
    (circuit: RegExp): boolean => circuit.test(window.location.host)
  );

  const full = /(http:|https:|\/\/)(.*)/.test(url);
  const email = url.includes("@");
  const domain = getDomain();

  // Полный адрес или email – как есть
  if (full || email) {
    return url;
  }

  // Если указан data-domain у скрипта подключения навигации – используем
  if (domain) {
    return `${domain}${url}`;
  }

  // На тестовых контурах ЕЛК – загружаем ресурсы по абсолютному пути с R
  if (isElkDevelopmentCircuit) {
    return `https://newmos.mos.ru${url}`;
  }

  // На всех остальны тестовых контурах по относительному пути
  if (isCircuit) {
    return location.protocol + "//" + location.host + url;
  }

  // mos.ru, остальные домены ЕВП и внешние – ссылаются на mos.ru
  return `https://www.mos.ru${url}`;
}
